"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyringController = void 0;
const wallet_1 = __importDefault(require("../services/wallet"));
const user_1 = __importDefault(require("../services/user"));
const multichain_1 = require("../utils/helper/multichain");
const Sentry = __importStar(require("@sentry/browser"));
// 1. Extending Multichain only for getSigner for evmChainData for did creation
class KeyringController extends multichain_1.Multichain {
    /**
     * Constructs a new instance of the Tria class.
     * @param apiUrl - The URL of the API.
     */
    constructor({ baseUrl, walletType, sentryDns, environment }) {
        super(baseUrl, walletType);
        this.apiUrl = baseUrl;
        this.walletService = new wallet_1.default(this.apiUrl);
        this.userService = new user_1.default(this.apiUrl);
        this.environment = environment || 'mainnet';
        if (sentryDns) {
            console.log('sentryDns', sentryDns);
            Sentry.init({
                dsn: sentryDns,
                release: 'tria-sdk/web',
                integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
                tracesSampleRate: 1.0,
                tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
                replaysSessionSampleRate: 0.1,
                replaysOnErrorSampleRate: 1.0,
            });
        }
        // const oldMemData = this.store.getValue(TEMP_MEM_STORE);
        // this.store.removeValue(TEMP_MEM_STORE);
    }
    getSigner(chainName, privateKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const chainInstance = this.chains[chainName];
            let signer, triaName, address;
            if (!this.walletType.embedded) {
                // @ts-ignore
                ({ signer } = yield chainInstance.getSigner());
                address = yield signer.getAddress();
                triaName = null;
            }
            return { signer, chainInstance, triaName, address };
        });
    }
    /**
     * @param triaName triaName
     * @param chainName chainName
     */
    resolveTriaName(triaName, chainName) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.walletService.resolveTriaName({ chainName, lookUpTriaName: triaName }, this.environment);
            return res.address;
        });
    }
    /**
     * For message passing between windows and iframes
     * @param windowTo
     * @param message
     */
    postMessage(message, sameOrigin = false) {
        var _a, _b;
        try {
            console.log('postMessage', message);
            console.log({ sameOrigin });
            if (sameOrigin) {
                const bc = new BroadcastChannel('Tria Auth Channel');
                bc.postMessage(JSON.stringify(message));
                if ((_a = window === null || window === void 0 ? void 0 : window.opener) === null || _a === void 0 ? void 0 : _a.postMessage) {
                    window.opener.postMessage(JSON.stringify(message), '*');
                }
                return;
            }
            if ((_b = window === null || window === void 0 ? void 0 : window.opener) === null || _b === void 0 ? void 0 : _b.postMessage) {
                window.opener.postMessage(JSON.stringify(message), '*');
            }
            else if (window === null || window === void 0 ? void 0 : window.parent) {
                window.parent.postMessage(JSON.stringify(message), document.referrer);
            }
        }
        catch (err) {
            console.error(err);
        }
    }
}
exports.KeyringController = KeyringController;
